module.exports = {"623021100":"城关镇","623021101":"新城镇","623021102":"冶力关镇","623021103":"羊永镇","623021104":"王旗镇","623021200":"初布乡","623021201":"古战回族乡","623021202":"卓洛回族乡","623021203":"长川回族乡","623021205":"流顺乡","623021206":"店子乡","623021207":"洮滨乡","623021208":"三岔乡","623021210":"石门乡","623021211":"羊沙乡","623021212":"八角乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623021.json
// module id = 2759
// module chunks = 0